<template>
    <div class="desc desc06" id="detail_community" style="display: block">
        <div class="title">커뮤니티 <p>{{ vueNumberFormat(this.commentCount) }}개</p></div>
            <div class="cont">
                <div class="util">
                    <div class="sort">
                        <button type="button" class="btnSort" :class="{ active: this.sort }" @click="this.toggleSort">
                            <p v-if="this.orderBy === 'likes'">인기순</p> 
                            <p v-if="this.orderBy === 'latest'">최신순</p> 
                            <i class="icon"></i>
                        </button>
                        <div class="menu" :class="{ active: this.sort }">
                            <ul>
                                <li><a href="javacript:;" :class="{ active: this.orderBy === 'likes' }"  @click="this.setOrder('likes')">인기순</a></li>
                                <li><a href="javacript:;" :class="{ active: this.orderBy === 'latest' }" @click='this.setOrder("latest")'>최신순</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="write">
                        <a :href="'/html/class_comment_write.php?it_id=' + this.lectureId" class="btn btn_04">글 작성하기</a>
                    </div>
                </div>
                <div class="list">
                    <ul>
                        <li v-for="(comment) in this.comments" v-bind:key="comment.id">
                            <div class="rep">
                                <div class="head">
                                    <div class="icon"><img :src='comment.writer.profile_image_url' v-if="comment.writer"></div>
                                    <div class="name">{{comment.writer.mb_nick}}</div>
                                    <div class="date">{{dayjs(comment.created_at).format('YYYY.MM.DD')}}</div>
                                </div>
                                <div class="img" v-if="comment.images.length">
                                    <img :src="image.url" v-bind:key="image.bf_id" v-for="(image) in comment.images">
                                </div>
                                <div class="text">{{comment.message}}</div>
                                <div class="button">
                                    <div>
                                    <a class="btn_like" :id="'like'+comment.id" @click='like(comment)'>
                                        <i class="icon"></i>
                                        <p>{{ vueNumberFormat(comment.likes_count) }}</p>
                                    </a>
                                    <a class="btn_reply" @click="setReply(comment)"><i class="icon"></i>
                                        <p>{{ vueNumberFormat(comment.replies.length )}}</p>
                                    </a>
                                </div>
                            </div>
                            <div class="tool" v-if="comment.is_owner">
                                <a class="btn_edit" :class="{ on: this.$refs.commentEdit.attrs !== null }" @click="editComment(comment)">
                                    <i class="icon"></i>
                                    <p class="skip">댓글수정</p>
                                </a>
                                <a class="btn_delete" @click="removeComment(comment)">
                                    <i class="icon"></i>
                                    <p class="skip">댓글삭제</p>
                                </a>
                            </div>
                        </div>
                        <div class="rep" style="padding-left:30px" v-for="(reply) in comment.replies" v-bind:key="reply.id">
                            <div class="head">
                                <div class="icon"><img :src="reply.writer.profile_image_url" v-if="reply.writer"></div>
                                <div class="name">{{reply.writer.mb_nick}}</div>
                                <div class="date">{{dayjs(reply.created_at).format('YYYY.MM.DD')}}</div>
                            </div>
                            <div class="img" v-if="reply.images">
                                <img :src="image.url" v-bind:key="image.bf_id" v-for="(image) in reply.images">
                            </div>
                            <div class="text">{{reply.message}}</div>
                            <div class="button">
                                <div>
                                    <a class="btn_like" :id="'like'+reply.id" @click='like(reply)'>
                                        <i class="icon"></i>
                                        <p>{{ vueNumberFormat(reply.likes_count) }}</p>
                                    </a>
                                </div>
                            </div>
                            <div class="tool" v-if='reply.is_owner'>
                                <a class="btn_edit" v-on:click='editComment(reply)'>
                                    <i class="icon"></i>
                                    <p class="skip">댓글수정</p>
                                </a>
                                <a class="btn_delete" v-on:click='removeComment(reply)'>
                                    <i class="icon"></i>
                                    <p class="skip">댓글삭제</p>
                                </a>
                            </div>
                        </div>
                        <form action="/v1/class-comments.php" method="post" class="write" @submit="postComment" v-if="comment.reply">
                            <input type="hidden" name="data[lecture_id]" :value="this.lectureId">
                            <input type="hidden" name="data[parent_id]" :value="comment.id">
                            <input type='hidden' name='attachment_ids[]' :value='image.bf_id' v-for='(image, i) in comment.reply.images' v-bind:key="i">
                            <div class="img" v-if='comment.reply.images.length'>
                                <ul>
                                    <li v-for='(image, i) in comment.reply.images' v-bind:key="i">
                                        <div>
                                            <input type="hidden" name="attachment_ids[]" :value="image.bf_id">
                                            <img :src="image.url">
                                            <a class="btn_remove" v-on:click='comment.images.splice(i, 1)'></a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="inp">
                                <div class="box">
                                    <label class="inp_file">
                                        <input type="file" accept="image/*" @change="handleImageUpload(comment.reply, $event)">
                                        <i class="icon"></i>
                                        <p class="skip">파일 첨부</p>
                                    </label>
                                    <input type="text" name="data[message]" class="inp_text" placeholder="댓글을 입력해주세요.">
                                    <button type="submit" class="inp_submit"><i class="icon"></i><p class="skip">댓글달기</p></button>
                                </div>
                            </div>
                        </form>
                    </li>
                </ul>
            </div>
                   </div>
    </div>
    <CommentEdit ref="commentEdit" @commentUpdated="handleCommentUpdated" />
</template>

<script>
import { inject } from 'vue'

import axios from "axios";
import CommentEdit from "./components/CommentEdit.vue";

export default {
    name: "App",
    data() {
        return {
            componentKey: 0,
            comments: [],
            commentCount: 0,
            images: [],
            sort: false,
            reply: null,
            orderBy: 'latest',
        }
    },
    props: {
        name: String,
        attrs: {
            type: Object,
            default: null,
        },
    },
    watch: {
        orderBy() {
            this.fetchComment(this.lectureId);
        }
    },
    mounted(){
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        const lectureId = searchParams.get("it_id");

        this.lectureId = lectureId

        this.fetchComment(lectureId);
    },

    setup() {
        const dayjs = inject("dayjs");

        let message = "";

        const more = (ev) => {
            ev.preventDefault();
        };

        const like = (comment) => {
            let ele = document.getElementById("like" + comment.id);
            const fdata = new FormData();

            fdata.append("id", comment.id);
            fdata.append("action", "likes");

            axios.post("/v1/class-comments.php", fdata).then(function () {
                ele.classList.add("on");
                comment.likes_count++;
            });
        };

        return {
            message,
            dayjs,
            like,
            more,
        };
    },
    methods: {
        toggleSort() {
            this.sort = !this.sort;
        },
        setOrder(order) {
            this.orderBy = order;
            this.sort = false;
        },
        postComment(ev) {
            ev.preventDefault();
            const data = new FormData(ev.target);
            axios.post(ev.target.action, data).then(() => {
                this.fetchComment(this.lectureId);
                ev.target.reset();
            }).catch((error) => console.error(error));
        },
        editComment(comment) {
            document.querySelector('#bg').classList.toggle('active')
            this.$refs.commentEdit.setAttrs(comment)
        },
        fetchComment(lectureId) {
            axios.get("/v1/class-comments.php", {
                params: {
                    preset_id: lectureId,
                    order_by: this.orderBy
                }
            }).then(({ data }) => {
                this.comments = []
                data.paginator.data.forEach(comment => {
                    // eslint-disable-next-line vue/no-mutating-props
                    this.comments.push(comment);
                });

                console.log(this.comments);

                // eslint-disable-next-line vue/no-mutating-props
                this.commentCount = data.paginator.total;
            }).catch((error) => console.error(error));
        },
        handleImageUpload(comment, e) {
            const files = e.target.files;
            const formData = new FormData();
            formData.append("file", files[0]);
            formData.append("disk", "_class_comments");
            axios.post("/v1/attachments.php", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then((response) => {
                const { url, bf_id } = response.data.data;
                // eslint-disable-next-line vue/no-mutating-props
                comment.images.splice(comment.images.length, 0, {
                    url: url,
                    bf_id: bf_id
                })
            });
        },
        removeComment(comment) {
            if (!confirm("삭제하시겠습니까?")) {
                return
            }

            const deleteComment = async () => {
                try {
                    await axios.delete(`/v1/class-comments.php?id=${comment.id}`)
                } catch(e) {
                    console.log(e)
                }
            }

            deleteComment()

            this.fetchComment(this.lectureId);
        },
        handleCommentUpdated() {
            this.fetchComment(this.lectureId);
        },
        setReply(comment) {
            if(comment.reply) {
                comment.reply = null
            } else {
                comment.reply = {
                    parent_id: comment.id,
                    lecture_id: this.lectureId,
                    content: '',
                    images: []
                }
                delete(comment.reply.id)
            }
        },
    },
    components: { CommentEdit }
}
</script>